<template>
  <ValidationObserver ref="editTalentPool">
    <Dialog :data="dialogSettings">
      <ValidationProvider v-slot="{ errors }" name="name" rules="required">
        <v-text-field
          class="mt-10"
          v-model="name"
          label="Name"
          :error-messages="showValidationErrors ? errors : ''"
        />
      </ValidationProvider>
      <template v-slot:dialog.actions>
        <PrimaryButton @click.native="close" text>Cancel</PrimaryButton>
        <PrimaryButton @click.native="onSubmit" :loading="isLoading">
          Save Changes
        </PrimaryButton>
      </template>
    </Dialog>
  </ValidationObserver>
</template>

<script>
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import Dialog from "@/components/common/Dialog";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { TALENT_POOLS_NAMESPACE } from "@/store/modules/talentPools";
import { EDIT_TALENT_POOL } from "@/store/modules/talentPools/actions";
import { createNamespacedHelpers } from "vuex";

const { mapActions, mapState } = createNamespacedHelpers(
  TALENT_POOLS_NAMESPACE
);

export default {
  name: "EditTalentPoolDialog",
  components: {
    Dialog,
    PrimaryButton,
    ValidationObserver,
    ValidationProvider
  },
  data() {
    return {
      name: "",
      showValidationErrors: false,
      isLoading: false,
      dialogSettings: {
        dialog: true,
        title: "Edit Talent Pool"
      }
    };
  },
  created() {
    this.name = this.currentTalentPool.name;
  },
  computed: {
    ...mapState({
      currentTalentPool: state => state.currentTalentPool
    }),
    currentTalentPoolId() {
      return this.currentTalentPool.id;
    }
  },
  methods: {
    ...mapActions({
      editTalentPool: EDIT_TALENT_POOL
    }),
    close() {
      this.$emit("close");
    },
    async onSubmit() {
      this.showValidationErrors = true;
      const isValid = await this.$refs.editTalentPool.validate();
      if (isValid) {
        this.isLoading = true;
        await this.editTalentPool({
          data: { name: this.name },
          id: this.currentTalentPoolId
        });
        this.close();
        this.isLoading = false;
      }
    }
  }
};
</script>

<style></style>
